<template>
  <div id="app">
    <div class="quiz">
      <div class="logo"></div>
      <div class="container">
        <transition name="side">
          <div v-if="introStage" class="start-view">
            <div class="start-view__wrapper">
              <div class="start-view__header">
                <h2>Olisiko DNA unelmiesi työpaikka?</h2>
              </div>
              <div class="start-view__content">
                <h4>Tee 30 sekunnin pikatesti!</h4>
              </div>
              <button @click="startQuiz" class="btn btn--hotpink">
                Aloita
              </button>
            </div>
          </div>
        </transition>
        <transition name="side">
          <div v-if="questionStage" class="question-view">
            <div class="question-view__header">
              <span>{{ currentQuestion + 1 }} / {{ questions.length }}</span>
            </div>
            <transition
              name="top"
              mode="out-in"
              duration-enter="0.25"
              duration-leave="0.45"
            >
              <question
                :key="currentQuestion"
                :question="questions[currentQuestion]"
                v-on:answer="handleAnswer"
                :question-number="currentQuestion + 1"
                :question-length="questions.length"
              />
            </transition>
          </div>
        </transition>
        <transition name="side">
          <div v-if="resultStage" class="result-view">
            <div class="result-view__wrapper">
              <div class="result-view__header">
                <h2>{{ resultTxt.header }}</h2>
              </div>
              <div class="result-view__ingress">
                <h4>{{ resultTxt.ingress }}</h4>
              </div>
              <div class="result-view__content">
                <p>{{ resultTxt.body }}</p>
              </div>
              <a v-if="this.correct >= 2" :href="resultTxt.url" class="link">{{
                resultTxt.input
              }}</a>
              <button @click="startAgain" class="link">
                Tee testi uudelleen
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Question from "./components/Question";

import "./styles/main.scss";

// For mobile 100vh
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);
window.addEventListener("resize", () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

export default {
  components: {
    Question,
  },
  data() {
    return {
      introStage: false,
      questionStage: false,
      resultStage: false,
      questions: [],
      currentQuestion: 0,
      answers: [],
      correct: 0,
      resultTxt: {
        header: "",
        ingress: "",
        body: "",
        input: "",
        url: "",
      },
    };
  },
  created() {
    fetch(process.env.BASE_URL + "questions.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        this.questions = res.questions;
        this.introStage = true;
      });
  },
  methods: {
    startQuiz() {
      this.introStage = false;
      this.questionStage = true;
    },
    handleAnswer(event) {
      this.answers[this.currentQuestion] = event.answer;
      if (this.currentQuestion === this.questions.length - 1) {
        this.handleResults();
        this.questionStage = false;
        this.resultStage = true;
      } else if (this.answers[0] === "Ei mikään näistä") {
        this.handleResults();
        this.questionStage = false;
        this.resultStage = true;
      } else {
        this.currentQuestion++;
      }
    },
    handleResults() {
      this.questions.forEach((a, index) => {
        if (this.answers[index] === a.answer) this.correct++;
      });

      if (this.correct < 2) {
        this.resultTxt.header = "Harmi!";
        (this.resultTxt.ingress =
          "Vaikuttaa siltä, että unelmiesi työpaikka on jossain muualla. Jos tulos yllätti sinut, voit aina kokeilla tehdä testin uudelleen."),
          (this.resultTxt.body = null);
        (this.resultTxt.input = "Tee testi uudelleen"),
          (this.resultTxt.url = this.questionStage);
      } else if (this.correct === 2) {
        this.resultTxt.header = "Kiitos!";
        (this.resultTxt.ingress =
          "Vaikuttaa siltä, että mutkaton työkulttuurimme ei täysin osu yksiin kanssasi."),
          (this.resultTxt.body =
            "Jos kuitenkin kiinnostuit, katso avoimet työmahdollisuutemme rekrysivultamme. Jos meillä ei juuri nyt ole tarjota sinulle osuvaa tehtävää, voit jättää meille avoimen hakemuksesi.");
        (this.resultTxt.input = "Katso avoimet paikat"),
          (this.resultTxt.url = "https://corporate.dna.fi/tyopaikat");
      } else if (this.correct > 2) {
        this.resultTxt.header = "Loistavaa!";
        (this.resultTxt.ingress =
          "Vaikuttaa siltä, että DNA saattaa olla unelmiesi työpaikka."),
          (this.resultTxt.body =
            "Katso avoimet työpaikat rekrysivultamme. Jos meillä ei juuri nyt ole tarjota sinulle osuvaa tehtävää, voit jättää meille avoimen hakemuksesi.");
        (this.resultTxt.input = "Katso avoimet paikat"),
          (this.resultTxt.url = "https://corporate.dna.fi/tyopaikat");
      }
    },
    startAgain() {
      this.questionStage = true;
      this.resultStage = false;
      this.currentQuestion = 0;
      this.correct = 0;
      this.answers = [];
    },
    isIE() {
      const ua = navigator.userAgent;
      const is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

      return is_ie;
    },
  },
};
</script>
